// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"742":"e3b28b23","798":"8ebdf759"}[chunkId] + ".css";
};